import React from "react";
import { useNavigate } from "react-router-dom";
import { useSiteContent } from "../context/SiteContentContext";
import { Button } from "@/components/ui/button";
import { Crown, Check, PawPrint } from "lucide-react";

const ACCENT = { silver: "#9CA3AF", gold: "#E19C00", den: "#7B2D3B" };

export default function Subscribe() {
  const { content } = useSiteContent();
  const navigate = useNavigate();
  const tiers = content.subscription_tiers || [];
  const frames = content.profile_frames || [];
  const frameFor = (tierKey) => frames.find((f) => f.tier === tierKey)?.url;

  return (
    <div className="max-w-5xl mx-auto" data-testid="subscribe-page">
      <div className="text-center mb-8">
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-spotter-maroon flex items-center justify-center gap-2"><PawPrint className="w-9 h-9" style={{ color: "#E19C00" }} />Spotter Premium</h1>
        <p className="text-spotter-maroon mt-3 max-w-2xl mx-auto whitespace-pre-wrap">{content.subscription_intro}</p>
      </div>
      <div className="grid md:grid-cols-3 gap-5">
        {tiers.map((t) => (
          <div key={t.key} data-testid={`tier-${t.key}`} className="bg-white border-4 border-black rounded-2xl p-5 brand-shadow flex flex-col">
            {frameFor(t.key) && (
              <div className="flex flex-col items-center mb-2">
                <img src={frameFor(t.key)} alt={`${t.name} frame`} data-testid={`tier-frame-${t.key}`} className="w-28 h-28 object-contain" />
                <span className="text-[11px] font-bold text-spotter-maroon/70 mt-1">Exclusive profile frame</span>
              </div>
            )}
            <div className="flex items-center gap-2 mb-1">
              <Crown className="w-6 h-6" style={{ color: ACCENT[t.key] || "#E19C00" }} />
              <h2 className="font-display text-2xl font-bold text-spotter-maroon">{t.name}</h2>
            </div>
            <span className="text-xs font-bold uppercase tracking-wide text-spotter-maroon/60">{t.badge}</span>
            <div className="my-3"><span className="text-4xl font-display font-bold text-spotter-maroon">${t.price}</span><span className="text-spotter-maroon">/{t.period}</span></div>
            <p className="text-sm text-spotter-maroon mb-4">{t.tagline}</p>
            <ul className="space-y-2 flex-1">
              {(t.features || []).map((f, i) => (
                <li key={i} className="flex items-start gap-2 text-[14px]"><Check className="w-4 h-4 mt-0.5 shrink-0" style={{ color: ACCENT[t.key] || "#E19C00" }} />{f}</li>
              ))}
            </ul>
            <Button data-testid={`choose-${t.key}`} onClick={() => navigate(`/cart?tier=${t.key}`)}
              className="mt-5 w-full bg-spotter-maroon text-spotter-cream font-heading font-bold border-2 border-black brand-shadow-sm">Choose {t.name}</Button>
          </div>
        ))}
      </div>
      <p className="text-center text-xs text-spotter-maroon/70 mt-6">Payments are handled directly via PayPal or Venmo. After paying, your tier is activated by an admin.</p>
    </div>
  );
}
